module.exports = __webpack_public_path__ + "img/dots.377a6196.svg";